import styled from 'styled-components';
import { Container } from '../UI/Containers';
import S from '../UI/variables';

export const StyledAboutWrapper = styled(Container)`
  position: relative;
  padding-top: 32px;
  padding-bottom: 16px;
  & > h2 {
    font-family: 'Judson', serif;
    font-size: 24px;
    font-weight: 700;
    text-transform: lowercase;
    &::first-letter {
      text-transform: uppercase;
    }
    margin-bottom: 12px;
    @media (min-width: ${S.tablet}) {
      padding-bottom: 32px;
      font-size: 48px;
    }
  }
`;

export const StyledAboutContentWrapper = styled.article`
  width: 100%;
  display: flex;
`;

export const StyledAboutContent = styled.div`
  width: 100%;
  @media screen and (min-width: ${S.tablet}) {
    min-width: 68%;
  }
`;

export const StyledAboutImage = styled.div`
  width: 100%;
  max-height: 500px;
  overflow: hidden;
  border-radius: 10px;
  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
  display: none;
  @media screen and (min-width: ${S.tablet}) {
    display: initial;
  }
`;

export const StyledAboutText = styled.h3`
  line-height: 1.6em;
  font-size: 14px;
  font-weight: 400;
  text-transform: lowercase;
  &::first-letter {
    text-transform: uppercase;
  }
  margin-bottom: 50px;
  @media (min-width: ${S.tablet}) {
    font-size: 20px;
    width: 60%;
  }
`;

export const StyledAboutCard = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid ${S.secondaryBorder};

  & > .icon {
    width: 71px;
    height: 71px;
    border-radius: 50%;
    background: ${S.accentGrey};
    padding: 5px;
    margin-bottom: 8px;
    & > svg {
      fill: ${S.categoriesIcon};
      width: 60px;
      height: 60px;
    }
  }

  & > h3 {
    font-family: 'Sora', sans-serif;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
  }
  @media (min-width: ${S.tablet}) {
    height: 170px;
    flex-direction: row;
    & > .icon {
      width: 89px;
      height: 89px;
      margin-bottom: 0;
      & > svg {
        width: 75px;
        height: 75px;
      }
    }
    & > h3 {
      font-size: 24px;
      margin-left: 36px;
      text-align: left;
    }
  }
`;

export const StyledFeaturesSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  @media screen and (min-width: ${S.tablet}) {
    width: 95%;
  }
  & .article {
    display: flex;
    width: 100%;
    margin-bottom: 5px;
    @media screen and (min-width: ${S.tablet}) {
      width: calc(50% - 20px);
      &:nth-child(2n - 1) {
        margin-right: 40px;
      }
    }
    & .article__icon {
      width: 68px;
      height: 68px;
      border-radius: 50%;
      overflow: visible;
      padding: 4px 4px 0 0;
      background: ${S.featuresIcons};
    }
    & .article__content {
      display: inline-block;
      padding: 16px;
      font-size: 14px;
      line-height: 1.5em;
      font-weight: 400;
    }
    & .article__title {
      font-family: 'Judson', serif;
      font-size: 20px;
      line-height: 1.5em;
      font-weight: 700;
      margin-bottom: 8px;
      text-transform: lowercase;
      &::first-letter {
        text-transform: uppercase;
      }
    }
  }
`;
